export const PER_PAGE_OWNER_INVENTORY = 'PER_PAGE_OWNER_INVENTORY'
export const PAGE_OWNER_INVENTORY = 'PAGE_OWNER_INVENTORY'
export const PAGES_OWNER_INVENTORY = 'PAGES_OWNER_INVENTORY'
export const IS_LOADING_TABLE_OWNER_INVENTORY = 'IS_LOADING_TABLE_OWNER_INVENTORY'
export const ARRAY_LIST_ALBUMS_TYPES_OWNER_INVENTORY = 'ARRAY_LIST_ALBUMS_TYPES_OWNER_INVENTORY'
export const ARRAY_LIST_ALBUMS_TYPES_FILES_OWNER_INVENTORY = 'ARRAY_LIST_ALBUMS_TYPES_FILES_OWNER_INVENTORY'
export const FORM_DATA_OWNER_INVENTORY = 'FORM_DATA_OWNER_INVENTORY'
